/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/tck/"

// Shared style definitions
const sectionTitleStyle =
  "font-['HelveticaNeue-Bold'] text-[32px] text-[#FFF] uppercase tracking-[0.02em] leading-[1]"
const itemTitleStyle =
  "font-['HelveticaNeue-Medium'] text-[22px] text-[#FFF] uppercase tracking-[0.02em]"
const itemSubtitleStyle = "font-['HelveticaNeue-Regular'] text-[13px] text-[#A7A7A7] uppercase"

const tck: CommunityData = {
  code: "tck",
  inviteCode: "tck",
  name: "Third Culture Kids",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/tck`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFF",
      alternativeLogo: {
        src: `${S3_PREFIX}logo-mobile.png`,
        styles: "w-[128px]",
      },
      logo: {
        src: `${S3_PREFIX}logo-web.png`,
        styles: "w-[128px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000",
      asideBg: "#000",
      asideStyles: "border-r border-[#A7A7A7]",
      contentBg: "#0A0A0A",
      contentBoxShadow: "",
      nonMemberBg: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['HelveticaNeue-Regular']",
      primaryButton:
        "bg-[#FFF] !text-[#000] px-6 py-4 rounded-none border border-[#FFF] font-['HelveticaNeue-Medium'] text-[13px] uppercase",
    },
    navigation: {
      iconsColor: "#FFF",
      sideBarSeparator: "#A7A7A7",
      separator: "#A7A7A7",
      item: "font-['HelveticaNeue-Regular'] text-[18px] text-[#FFF] uppercase opacity-50 text-center tracking-[0.04em]",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0 border-none rounded-none",
      titles: sectionTitleStyle,
      emptyOrLoadingState: `!mx-4 sm:!mx-8 ${itemSubtitleStyle}`,
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col py-4 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle: `${sectionTitleStyle} pl-4 sm:pl-8 !mb-4 sm:mb-6`,
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] h-[128px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover rounded-none",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-none",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: itemTitleStyle,
          subtitle: `${itemSubtitleStyle} mt-2`,
          location: `${itemSubtitleStyle} mt-2`,
          date: `${itemSubtitleStyle} mt-2`,
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: sectionTitleStyle,
        text: itemSubtitleStyle,
        customShopImage: "",
        // customShopImage: `${S3_PREFIX}web-shop.png`,
        customShopImageStyle: "!rounded-none !border-0 bg-gray-400",
        sectionTitle: `${sectionTitleStyle} !mb-4 !sm:mb-6`,
      },
    },
    eventV2: {
      container: "flex flex-col border-none rounded-none",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-none !border-0",
        title: sectionTitleStyle,
        subtitle: `${itemSubtitleStyle} mb-4 `,
        button: "!w-fit mb-4 sm:mb-0 rounded-none",
        questions: itemSubtitleStyle,
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: `${itemSubtitleStyle} mb-4 w-full`,
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: `${itemSubtitleStyle} mb-4  max-w-[652px] w-full !text-[#FFF]`,
        map: "w-full h-[206px] overflow-hidden rounded-none border border-[#000000]",
        mapPinColor: "",
        mapStrokeColor: "#000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: sectionTitleStyle,
        text: itemSubtitleStyle,
      },
      tickets: {
        header: sectionTitleStyle,
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col mt-4 rounded-none overflow-hidden",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 border-b border-[#A7A7A780]",
          media: "!hidden",
          name: "font-['HelveticaNeue-Medium'] text-[16px] text-[#FFF] uppercase tracking-[0.02em]",
          description: "font-['HelveticaNeue-Regular'] text-[13px] text-[#A7A7A7] uppercase ",
          price:
            "font-['HelveticaNeue-Medium'] text-[16px] text-[#A7A7A7] uppercase tracking-[0.02em]",
          quantity: "font-['HelveticaNeue-Regular'] text-[13px] text-[#A7A7A7] uppercase ",
          status:
            "font-['HelveticaNeue-Medium'] text-[16px] text-[#FFF] uppercase tracking-[0.02em]",
          counterContainer:
            "bg-transparent !w-fit font-['HelveticaNeue-Medium'] text-[13px] rounded-none border border-[#FFF]",
          button:
            "font-['HelveticaNeue-Medium'] text-[13px] py-2 px-3 bg-transparent !w-fit rounded-none border border-[#FFF] text-[#FFF] uppercase",
          plusMinusColor: "#FFF",
          descriptionCutoff: 27,
        },
      },
    },
    eventTickets: {
      container: "border-none rounded-none",
      separator: "#A7A7A7",
      event: {
        title: itemTitleStyle,
        subtitle: itemSubtitleStyle,
        media: "w-full h-full object-cover rounded-none",
      },
      ticket: {
        container: "border-none rounded-none",
        title: itemTitleStyle,
        description: itemSubtitleStyle,
        media: "w-full h-full object-cover rounded-none",
        text: itemSubtitleStyle,
        price: itemTitleStyle,
        status: itemTitleStyle,
        counterContainer:
          "bg-transparent !w-fit font-['HelveticaNeue-Medium'] text-[13px] rounded-none border border-[#FFF]",
        plusMinusColor: "#FFF",
        quantity: itemSubtitleStyle,
      },
    },
  },
}

export default tck
